var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77778 20H18.2222C18.6937 20 19.1459 19.8314 19.4793 19.5314C19.8127 19.2313 20 18.8244 20 18.4001V11.2003C20.0007 11.0951 19.9782 10.9907 19.934 10.8932C19.8898 10.7958 19.8246 10.7071 19.7422 10.6324L12.6311 4.23262C12.4646 4.08363 12.2393 4 12.0044 4C11.7696 4 11.5443 4.08363 11.3778 4.23262L4.26667 10.6324C4.18268 10.7065 4.11586 10.7948 4.07008 10.8923C4.02431 10.9898 4.00049 11.0945 4 11.2003V18.4001C4 18.8244 4.1873 19.2313 4.5207 19.5314C4.8541 19.8314 5.30628 20 5.77778 20ZM10.2222 20V14.4002H13.7778V20H10.2222ZM5.77778 11.5283L12 5.92856L18.2222 11.5283V18.4001H15.5555V14.4002C15.5555 13.9759 15.3682 13.5689 15.0348 13.2689C14.7014 12.9688 14.2493 12.8003 13.7778 12.8003H10.2222C9.75072 12.8003 9.29854 12.9688 8.96514 13.2689C8.63174 13.5689 8.44444 13.9759 8.44444 14.4002V18.4001H5.77778V11.5283Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3d554fdd2527455ae1442680ff15fae3.svg";
export { ForwardRef as ReactComponent };